import React, { Component } from 'react'
import intl from 'react-intl-universal'
import { inject, observer, PropTypes } from 'mobx-react'
import Page from './Page'
import AuthorisationHandler from '../components/AuthorisationHandler'
import ProfileMenu from '../components/ProfileMenu'
import Reviews from '../components/Reviews'
import object_value from '../api/object_value'

@inject('user')
@observer
class ProfilePage extends Component {
  render () {
    const { user } = this.props
    console.log('ProfilePage.js - user:', user)

    const image_url = user.image_url
    const image_style = image_url
      ? { backgroundImage: 'url(' + image_url + ')' }
      : {}

    let reviews = object_value(user, 'ratings_organiser')

    return (
      <AuthorisationHandler>
        <Page title='Profile'>
          <section className='b-profile'>
            <div className='b-profile-inner'>

              <ProfileMenu />

              <div className='b-profile-main'>
                <div className='b-profile-author'>
                  <div className='b-profile-author-picture'
                       style={image_style} />
                  <div className='b-profile-author-name'>{user.prename} {user.surname}</div>
                </div>
                <p className='lead'>{user.description}</p>
                {/*<p className='not-working'>
                  Quisque placerat facilisis egestas cillum dolore. Pellentesque habitant morbi tristique senectus et
                  netus. Morbi fringilla convallis sapien, id pulvinar odio volutpat. Mercedem aut nummos unde unde
                  extrica.
                </p>*/}
                <hr />
                <div className='b-profile-block'>
                  <div className='b-profile-block-label'>{intl.get('public_profile.latest_reviews')}</div>
                  <div className='b-profile-block-value'>
                    {reviews.length > 0
                      ? <Reviews reviews={reviews} />
                      : <span>{intl.get('public_profile.no_reviews')}</span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </section>
        </Page>
      </AuthorisationHandler>
    )
  }
}

ProfilePage.propTypes = {
  user: PropTypes.observableObject
}

export default ProfilePage



// WEBPACK FOOTER //
// ./src/containers/ProfilePage.js